// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section.solutions {
  background: #f8f8f8;
  perspective: 1000px;
  overflow: hidden;
}

.flipbook-section {
  opacity: 0;
  transform: rotateY(-15deg) translateZ(-100px);
  transform-style: preserve-3d;
  transition: all 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.flipbook-section.flipbook-visible {
  opacity: 1;
  transform: rotateY(0deg) translateZ(0);
}

.solutions-content-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2.5rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem 0;
}

.solution-column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.solution-icon {
  text-align: center;
  margin-bottom: 1rem;
}

.solution-icon svg {
  width: 100px;
  height: 100px;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
  transition: transform 0.3s ease;
}

.solution-icon:hover svg {
  transform: scale(1.1);
}

.solution-header {
  text-align: left;
}

.solution-header h3 {
  font-size: 1.9rem;
  font-weight: 900;
  color: #000;
  margin-bottom: 1.25rem;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: -1px;
}

.solution-header p {
  font-size: 1rem;
  line-height: 1.7;
  color: #333;
  margin: 0;
}

.solution-toggles {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.solution-toggle {
  background: #fff;
  border-radius: 8px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  overflow: hidden;
}

.solution-toggle:hover {
  border-color: #ffbb00;
  box-shadow: 0 4px 12px rgba(255, 187, 0, 0.2);
}

.solution-toggle.open {
  border-color: #ffbb00;
  background: #fff;
  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);
}

.solution-toggle-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #000;
  padding: 1rem 1.25rem;
  margin: 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  transition: color 0.3s ease;
}

.solution-toggle-title:hover {
  color: #ffbb00;
}

.toggle-icon {
  font-size: 1.5rem;
  font-weight: 900;
  color: #ffbb00;
  transition: transform 0.3s ease;
}

.solution-toggle.open .toggle-icon {
  transform: rotate(45deg);
}

.solution-toggle-content {
  padding: 0 1.25rem 1.25rem;
  animation: slideDown 0.3s ease-out;
}

.solution-toggle-content p {
  font-size: 1rem;
  line-height: 1.7;
  color: #555;
  margin: 0;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.solution-cta {
  text-align: left;
  margin-top: 0.5rem;
}

.solution-cta .btn {
  font-size: 1.1rem;
  padding: 14px 35px;
  font-weight: 700;
  text-decoration: none;
  display: inline-block;
}

@media (min-width: 768px) {
  .solutions-content-wrapper {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 3rem;
    padding: 2rem 0;
  }

  .solution-header {
    text-align: inherit;
  }

  .solution-header h3 {
    font-size: 2.2rem;
  }

  .solution-header p {
    font-size: 1.05rem;
  }

  .solution-toggles {
    gap: 1rem;
  }

  .solution-toggle-title {
    font-size: 1.15rem;
    padding: 1.2rem 1.5rem;
  }

  .solution-toggle-content {
    padding: 0 1.5rem 1.5rem;
  }

  .solution-cta {
    text-align: right;
  }

  .solution-column-right .solution-cta {
    text-align: left;
  }
}

/*
 * Featured solution: SB 574 Readiness (AI Compliance)
 * Soft UI card + the AI Compliance redline motif. Deletion red appears only in
 * the genuine before/after redline; insertion blue is the emphasis color.
 */
.featured-solution {
  --fs-ink: #141727;
  --fs-text: #344767;
  --fs-muted: #67748e;
  --fs-strike: #b42318;
  --fs-insert: #1849a9;
  --fs-gold: #ffbc00;
  --fs-gold-deep: #e89a00;
  --fs-hairline: #e9ecef;

  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto 3.5rem;
  padding: 2rem 1.5rem;
  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);
}

.featured-eyebrow {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.625rem;
  margin-bottom: 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--fs-muted);
}

.featured-eyebrow-badge {
  padding: 0.25rem 0.6rem;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--fs-ink);
  border-radius: 0.375rem;
  background-image: linear-gradient(310deg, var(--fs-gold-deep) 0%, var(--fs-gold) 100%);
}

.featured-title {
  margin: 0 0 1rem;
  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 500;
  line-height: 1.1;
  letter-spacing: -0.015em;
  color: var(--fs-ink);
}

.featured-redline {
  margin: 0 0 1.25rem;
  padding-left: 1rem;
  border-left: 2px solid var(--fs-insert);
  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;
  font-size: clamp(1.1rem, 1.9vw, 1.3rem);
  line-height: 1.6;
}

.featured-redline del {
  display: block;
  color: var(--fs-strike);
  text-decoration: line-through;
  text-decoration-thickness: 1.5px;
}

.featured-redline ins {
  display: block;
  color: var(--fs-insert);
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-thickness: 1.5px;
}

.featured-lede {
  margin: 0 0 1.5rem;
  font-size: 1rem;
  line-height: 1.7;
  color: var(--fs-text);
}

.featured-solution .solution-toggle {
  border: 1px solid var(--fs-hairline);
  border-radius: 0.75rem;
}

.featured-solution .solution-toggle:hover,
.featured-solution .solution-toggle.open {
  border-color: rgba(24, 73, 169, 0.35);
  box-shadow: 0 8px 26px -4px rgba(20, 20, 20, 0.08);
}

.featured-solution .solution-toggle-title {
  gap: 1rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--fs-ink);
}

.featured-solution .solution-toggle-title:hover,
.featured-solution .toggle-icon {
  color: var(--fs-insert);
}

.featured-solution .solution-toggle-content p {
  font-size: 0.95rem;
  color: var(--fs-text);
}

.featured-modes {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.featured-mode {
  padding: 1rem 1.25rem;
  background: #f8f9fa;
  border-radius: 0.75rem;
}

.featured-mode-head {
  display: flex;
  align-items: baseline;
  gap: 0.625rem;
  margin-bottom: 0.25rem;
}

.featured-mode-num {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--fs-insert);
}

.featured-mode-label {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--fs-ink);
}

.featured-mode-price {
  margin-left: auto;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--fs-ink);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.featured-mode-name {
  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--fs-ink);
}

.featured-mode-cadence {
  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--fs-muted);
}

.featured-mode-body {
  margin: 0.375rem 0 0;
  font-size: 0.875rem;
  line-height: 1.6;
  color: var(--fs-text);
}

.featured-cta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem 1.5rem;
  margin-top: 1.5rem;
}

.featured-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.875rem 1.75rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  text-decoration: none;
  border-radius: 0.5rem;
  box-shadow: 0 4px 7px -1px rgba(0, 0, 0, 0.11), 0 2px 4px -1px rgba(0, 0, 0, 0.07);
  transition: transform 0.15s ease-in, box-shadow 0.15s ease-in, background-image 0.15s ease-in;
}

.featured-btn:hover {
  transform: scale(1.02);
  box-shadow: 0 7px 14px -1px rgba(0, 0, 0, 0.18), 0 2px 4px -1px rgba(0, 0, 0, 0.11);
}

.featured-btn-dark {
  color: #fff;
  background-image: linear-gradient(310deg, #141727 0%, #3a416f 100%);
}

.featured-btn-dark:hover {
  color: #fff;
  background-image: linear-gradient(310deg, #0f2a6b 0%, var(--fs-insert) 100%);
}

.featured-btn-link {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--fs-insert);
  text-decoration: underline;
  text-underline-offset: 4px;
}

.featured-btn-link:hover {
  color: var(--fs-ink);
}

.featured-solution a:focus-visible,
.featured-solution .solution-toggle-title:focus-visible {
  outline: 2px solid var(--fs-insert);
  outline-offset: 3px;
}

.featured-disclaimer {
  margin: 1rem 0 0;
  font-size: 0.75rem;
  color: var(--fs-muted);
}

@media (prefers-reduced-motion: reduce) {
  .featured-btn,
  .featured-btn:hover {
    transform: none;
    transition: none;
  }
}

@media (min-width: 980px) {
  .featured-solution {
    grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);
    gap: 3rem;
    padding: 3rem;
  }

  .featured-solution-side {
    padding-left: 3rem;
    border-left: 1px solid var(--fs-hairline);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/frontpage/components/Solutions.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,6CAA6C;EAC7C,4BAA4B;EAC5B,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iDAAiD;EACjD,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE;IACE,gDAAgD;IAChD,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE;AACF;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;;EAEtB,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,sEAAsE;EACtE,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,sFAAsF;AACxF;;AAEA;EACE,gBAAgB;EAChB,0DAA0D;EAC1D,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,0DAA0D;EAC1D,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,0DAA0D;EAC1D,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sEAAsE;EACtE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,kFAAkF;EAClF,6FAA6F;AAC/F;;AAEA;EACE,sBAAsB;EACtB,mFAAmF;AACrF;;AAEA;EACE,WAAW;EACX,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uDAAuD;IACvD,SAAS;IACT,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,yCAAyC;EAC3C;AACF","sourcesContent":["section.solutions {\n  background: #f8f8f8;\n  perspective: 1000px;\n  overflow: hidden;\n}\n\n.flipbook-section {\n  opacity: 0;\n  transform: rotateY(-15deg) translateZ(-100px);\n  transform-style: preserve-3d;\n  transition: all 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.flipbook-section.flipbook-visible {\n  opacity: 1;\n  transform: rotateY(0deg) translateZ(0);\n}\n\n.solutions-content-wrapper {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 2.5rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1.5rem 0;\n}\n\n.solution-column {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.solution-icon {\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.solution-icon svg {\n  width: 100px;\n  height: 100px;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));\n  transition: transform 0.3s ease;\n}\n\n.solution-icon:hover svg {\n  transform: scale(1.1);\n}\n\n.solution-header {\n  text-align: left;\n}\n\n.solution-header h3 {\n  font-size: 1.9rem;\n  font-weight: 900;\n  color: #000;\n  margin-bottom: 1.25rem;\n  line-height: 1.2;\n  text-transform: uppercase;\n  letter-spacing: -1px;\n}\n\n.solution-header p {\n  font-size: 1rem;\n  line-height: 1.7;\n  color: #333;\n  margin: 0;\n}\n\n.solution-toggles {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.solution-toggle {\n  background: #fff;\n  border-radius: 8px;\n  border: 2px solid transparent;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.solution-toggle:hover {\n  border-color: #ffbb00;\n  box-shadow: 0 4px 12px rgba(255, 187, 0, 0.2);\n}\n\n.solution-toggle.open {\n  border-color: #ffbb00;\n  background: #fff;\n  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);\n}\n\n.solution-toggle-title {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #000;\n  padding: 1rem 1.25rem;\n  margin: 0;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  user-select: none;\n  transition: color 0.3s ease;\n}\n\n.solution-toggle-title:hover {\n  color: #ffbb00;\n}\n\n.toggle-icon {\n  font-size: 1.5rem;\n  font-weight: 900;\n  color: #ffbb00;\n  transition: transform 0.3s ease;\n}\n\n.solution-toggle.open .toggle-icon {\n  transform: rotate(45deg);\n}\n\n.solution-toggle-content {\n  padding: 0 1.25rem 1.25rem;\n  animation: slideDown 0.3s ease-out;\n}\n\n.solution-toggle-content p {\n  font-size: 1rem;\n  line-height: 1.7;\n  color: #555;\n  margin: 0;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.solution-cta {\n  text-align: left;\n  margin-top: 0.5rem;\n}\n\n.solution-cta .btn {\n  font-size: 1.1rem;\n  padding: 14px 35px;\n  font-weight: 700;\n  text-decoration: none;\n  display: inline-block;\n}\n\n@media (min-width: 768px) {\n  .solutions-content-wrapper {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 3rem;\n    padding: 2rem 0;\n  }\n\n  .solution-header {\n    text-align: inherit;\n  }\n\n  .solution-header h3 {\n    font-size: 2.2rem;\n  }\n\n  .solution-header p {\n    font-size: 1.05rem;\n  }\n\n  .solution-toggles {\n    gap: 1rem;\n  }\n\n  .solution-toggle-title {\n    font-size: 1.15rem;\n    padding: 1.2rem 1.5rem;\n  }\n\n  .solution-toggle-content {\n    padding: 0 1.5rem 1.5rem;\n  }\n\n  .solution-cta {\n    text-align: right;\n  }\n\n  .solution-column-right .solution-cta {\n    text-align: left;\n  }\n}\n\n/*\n * Featured solution: SB 574 Readiness (AI Compliance)\n * Soft UI card + the AI Compliance redline motif. Deletion red appears only in\n * the genuine before/after redline; insertion blue is the emphasis color.\n */\n.featured-solution {\n  --fs-ink: #141727;\n  --fs-text: #344767;\n  --fs-muted: #67748e;\n  --fs-strike: #b42318;\n  --fs-insert: #1849a9;\n  --fs-gold: #ffbc00;\n  --fs-gold-deep: #e89a00;\n  --fs-hairline: #e9ecef;\n\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto 3.5rem;\n  padding: 2rem 1.5rem;\n  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;\n  background: #fff;\n  border-radius: 1rem;\n  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);\n}\n\n.featured-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.625rem;\n  margin-bottom: 1rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--fs-muted);\n}\n\n.featured-eyebrow-badge {\n  padding: 0.25rem 0.6rem;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: var(--fs-ink);\n  border-radius: 0.375rem;\n  background-image: linear-gradient(310deg, var(--fs-gold-deep) 0%, var(--fs-gold) 100%);\n}\n\n.featured-title {\n  margin: 0 0 1rem;\n  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;\n  font-size: clamp(2rem, 4vw, 2.75rem);\n  font-weight: 500;\n  line-height: 1.1;\n  letter-spacing: -0.015em;\n  color: var(--fs-ink);\n}\n\n.featured-redline {\n  margin: 0 0 1.25rem;\n  padding-left: 1rem;\n  border-left: 2px solid var(--fs-insert);\n  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;\n  font-size: clamp(1.1rem, 1.9vw, 1.3rem);\n  line-height: 1.6;\n}\n\n.featured-redline del {\n  display: block;\n  color: var(--fs-strike);\n  text-decoration: line-through;\n  text-decoration-thickness: 1.5px;\n}\n\n.featured-redline ins {\n  display: block;\n  color: var(--fs-insert);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  text-decoration-thickness: 1.5px;\n}\n\n.featured-lede {\n  margin: 0 0 1.5rem;\n  font-size: 1rem;\n  line-height: 1.7;\n  color: var(--fs-text);\n}\n\n.featured-solution .solution-toggle {\n  border: 1px solid var(--fs-hairline);\n  border-radius: 0.75rem;\n}\n\n.featured-solution .solution-toggle:hover,\n.featured-solution .solution-toggle.open {\n  border-color: rgba(24, 73, 169, 0.35);\n  box-shadow: 0 8px 26px -4px rgba(20, 20, 20, 0.08);\n}\n\n.featured-solution .solution-toggle-title {\n  gap: 1rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--fs-ink);\n}\n\n.featured-solution .solution-toggle-title:hover,\n.featured-solution .toggle-icon {\n  color: var(--fs-insert);\n}\n\n.featured-solution .solution-toggle-content p {\n  font-size: 0.95rem;\n  color: var(--fs-text);\n}\n\n.featured-modes {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.featured-mode {\n  padding: 1rem 1.25rem;\n  background: #f8f9fa;\n  border-radius: 0.75rem;\n}\n\n.featured-mode-head {\n  display: flex;\n  align-items: baseline;\n  gap: 0.625rem;\n  margin-bottom: 0.25rem;\n}\n\n.featured-mode-num {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--fs-insert);\n}\n\n.featured-mode-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--fs-ink);\n}\n\n.featured-mode-price {\n  margin-left: auto;\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: var(--fs-ink);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.featured-mode-name {\n  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--fs-ink);\n}\n\n.featured-mode-cadence {\n  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--fs-muted);\n}\n\n.featured-mode-body {\n  margin: 0.375rem 0 0;\n  font-size: 0.875rem;\n  line-height: 1.6;\n  color: var(--fs-text);\n}\n\n.featured-cta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1rem 1.5rem;\n  margin-top: 1.5rem;\n}\n\n.featured-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.875rem 1.75rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  text-decoration: none;\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 7px -1px rgba(0, 0, 0, 0.11), 0 2px 4px -1px rgba(0, 0, 0, 0.07);\n  transition: transform 0.15s ease-in, box-shadow 0.15s ease-in, background-image 0.15s ease-in;\n}\n\n.featured-btn:hover {\n  transform: scale(1.02);\n  box-shadow: 0 7px 14px -1px rgba(0, 0, 0, 0.18), 0 2px 4px -1px rgba(0, 0, 0, 0.11);\n}\n\n.featured-btn-dark {\n  color: #fff;\n  background-image: linear-gradient(310deg, #141727 0%, #3a416f 100%);\n}\n\n.featured-btn-dark:hover {\n  color: #fff;\n  background-image: linear-gradient(310deg, #0f2a6b 0%, var(--fs-insert) 100%);\n}\n\n.featured-btn-link {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--fs-insert);\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.featured-btn-link:hover {\n  color: var(--fs-ink);\n}\n\n.featured-solution a:focus-visible,\n.featured-solution .solution-toggle-title:focus-visible {\n  outline: 2px solid var(--fs-insert);\n  outline-offset: 3px;\n}\n\n.featured-disclaimer {\n  margin: 1rem 0 0;\n  font-size: 0.75rem;\n  color: var(--fs-muted);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .featured-btn,\n  .featured-btn:hover {\n    transform: none;\n    transition: none;\n  }\n}\n\n@media (min-width: 980px) {\n  .featured-solution {\n    grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);\n    gap: 3rem;\n    padding: 3rem;\n  }\n\n  .featured-solution-side {\n    padding-left: 3rem;\n    border-left: 1px solid var(--fs-hairline);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
